import { createContext, useContext, useState } from 'react'
import { PapsContext } from '../cnr/contexts/PapsContext'
import { cn_s, cn_snp, g_cns } from '../common/cns'
import { AppContentContext } from '../page/AppContent'
import AppView from '../page/AppView'
import { currentHelpers } from '../redirection/current'

export const DesktopContext = createContext();

/**
 * 
 * @param {*} props (innerRef, wrapper, banner, menu, content, navigation, footer, css, asSegment, inverted)
 * @returns a div `wrapper` that will include some additional classNames to help control the css settings.
 */
const DesktopWrapper = (props) => {

  const { innerRef, topNav, banner, menu, content, navigation, footer } = props

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { view, otherView, pathViews, landingView } = paps_state ?? {}
  let { viewKey } = paps_state ?? {}

  let trueView = (viewKey || otherView) ? view : view + '_list'
  trueView = currentHelpers.getTrueView(pathViews, view, trueView, landingView, viewKey)

  const appContentContext = useContext(AppContentContext)
  const { appContent_state } = appContentContext ? appContentContext : {}
  const {
    asSegment,
    css,
    inverted,
  } = appContent_state

  const { container: css_container, header: css_banner, menu: css_menu, content: css_content, navigation: css_navigation, footer: css_footer } = css ? css : {}

  const [desktop_state, setDesktop_state] = useState({ forDesktop: true, selectedPage: null, selectedPageItem: null })

  const { selectedPage } = desktop_state ?? {}

  let cssT = css_container ? ' ' + css_container : ''
  let cssB = css_banner ? ' ' + css_banner : ''
  let cssM = css_menu ? ' ' + css_menu : ''
  let cssC = css_content ? ' ' + css_content : ''
  let cssN = css_navigation ? ' ' + css_navigation : ''
  let cssF = css_footer ? ' ' + css_footer : ''

  let prefix = ' ';

  if (banner) { prefix += 'b' }
  if (menu) { prefix += 'm' }
  if (content) { prefix += 'c' }
  if (navigation) { prefix += 'n' }
  if (footer) { prefix += 'f' }

  if (cssM) { cssT += ' ' + cssM }

  const mainCn = 'app'
  let cn = g_cns.app_container

  if (asSegment) {
    cssT += ' ui segments'
    cssM += cn_s(inverted)
    cssB += cn_s(inverted)
    cssC += cn_snp(inverted)
    cssN += cn_s(inverted)
    cssF += cn_s(inverted)
  }

  const handleGridItemClick = (opts) => {
    const _desktop_state = { ...desktop_state }
    _desktop_state.selectedPage = opts.clickedItem.key
    setDesktop_state(_desktop_state)
  }

  const handleCollectionClick = (opts) => {
    const _desktop_state = { ...desktop_state }
    _desktop_state.selectedPageItem = opts.clickedItem.key
    setDesktop_state(_desktop_state)
  }

  const desktop_handlers = {
    handleItemClick: handleGridItemClick,
    handleCollectionClick: handleCollectionClick,
  }

  return <DesktopContext.Provider value={{ desktop_state, desktop_handlers }}>
    <div>
      {topNav}
      {selectedPage && <AppView
        fromDesktop={true}
      >
        <div>{'Selected - ' + selectedPage}</div>
      </AppView>}
    </div>
  </DesktopContext.Provider>

}

export default DesktopWrapper